export const setFeatureToggle = 'setFeatureToggle';
